<div class="forgot-password-container">
  <!-- Logo Section -->
  <div class="logo-section">
    <img class="logo" src="/assets/img/fleetoperate_logo.jpg" alt="FleetOperate Logo" />
  </div>

  <div class="forgot-password-card">
    <!-- Header Section -->
    <div class="header-section">
      <div class="icon-section">
        <mat-icon class="forgot-icon">lock_reset</mat-icon>
      </div>
      <h1 class="forgot-title">Reset Password</h1>
      <p class="forgot-subtitle">{{ message }}</p>
    </div>

    <!-- Main Content -->
    <div class="forgot-content">
      <!-- Error Message -->
      @if (verificationRequired) {
        <section class="verification-section" aria-labelledby="verification-title">
          <div class="verification-prompt" role="alert">
            <mat-icon aria-hidden="true">mark_email_unread</mat-icon>
            <div>
              <h2 id="verification-title">Verify your email</h2>
              <p>{{ errorMessage }}</p>
            </div>
          </div>

          <button
            mat-raised-button
            color="primary"
            type="button"
            class="resend-verification-button full-width"
            [disabled]="resendVerificationLoading || resendVerificationCooldown"
            (click)="resendVerificationEmail()"
            data-test="resend-verification-button"
            >
            <mat-icon aria-hidden="true">{{ resendVerificationLoading ? 'hourglass_empty' : 'send' }}</mat-icon>
            <span>{{ resendVerificationLoading ? 'Sending...' : 'Resend verification email' }}</span>
          </button>
        </section>
      } @else if (errorMessage) {
        <mat-error class="error-message" data-test="form-error-message">
          <mat-icon>error</mat-icon>
          {{ errorMessage }}
        </mat-error>
      }

      <!-- Forgot Password Form -->
      <form [formGroup]="form" #forgotPasswordForm="ngForm" (ngSubmit)="onSubmit(forgotPasswordForm)" class="forgot-form">
        <div class="form-fields">
          <!-- Email Field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input
              type="email"
              inputmode="email"
              matInput
              formControlName="email"
              data-test="email-form-field"
              autocomplete="email"
              />
            <mat-icon matPrefix>email</mat-icon>
            @if (form.get('email')?.touched && form.get('email')?.invalid) {
              <mat-error>
                {{ getEmailErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Submit Button -->
        <button
          class="submit-button full-width"
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="form.pristine || !form.valid || loading || verificationRequired"
          data-test="submit-button"
          >
          @if (loading) {
            <mat-icon>refresh</mat-icon>
          }
          {{ loading ? 'Sending...' : 'Send Reset Link' }}
        </button>

        <!-- Back to Sign In Link -->
        <div class="action-links">
          <a [routerLink]="[]" (click)="onNavigateToSignIn()" class="link" data-test="backto-signin-link">
            <mat-icon>arrow_back</mat-icon>
            Back to Sign In
          </a>
        </div>
      </form>
    </div>
  </div>
</div>
